import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ThrowStmt } from '@angular/compiler';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { forEach } from '@angular/router/src/utils/collection';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { FileManager_API, FileManager_PATH } from '../../constants';
import { Data } from '../../models/data';
import { FileDownloadModel } from '../../models/file-download-model';
import { FileHelperService } from '../../services/file-helper.service';
import { SpinnerComponent } from '../../shared';
import { randomNumber, randomString } from '../../shared/generateRandom';
import { DeviceHelper } from '../../shared/helpers';

@Component({
    selector: 'app-file-handler',
    templateUrl: './file-handler.component.html',
    styleUrls: ['./file-handler.component.scss'],
    providers: [FileHelperService],
})
export class FileHandlerComponent implements OnInit {

    @ViewChild('fileInput') public fileInput: ElementRef;
    @ViewChild(SpinnerComponent) spinner: SpinnerComponent;
    @Input() files: any[];
    @Input() isLoading: boolean = false;
    @Input() moduleId: number;
    @Input() siteId: number;
    @Input() model: any;
    @Input() role: any;
    @Input() isDocumentManager: boolean = false;
    @Input() allTemplate: boolean;
    @Input() previousFiles: any[];
    @Input() taskId: number;
    @Input() filesToBeSent: any[];
    @Input() sendFilesMode = false
    @Input() name = ""

    @Input() history: any[];
    @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() hasFiles: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() filesLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() updateFilesToBeUploaded: EventEmitter<any[]> = new EventEmitter<any[]>();

    public filesToBeUploaded = [];
    shownFiles = []
    hiddenFiles = []
    fileLoading: boolean = false;
    progress = 0;
    fileProgress = []
    uploading = false;
    user = JSON.parse(localStorage.getItem('currentUser'));
    requests = []
    request: any
    mergeFileRequest = false
    uploadChunksRequest = false
    fileSelected: any = null
    isCancellingRequest = false
    chunkedFilesFolderName = ""
    localPath = ""
    pathName = "";
    isExpanded = true
    rootPath = ""
    eventsLength = 0
    uploadedFileCtr = 0
    isMobile = false

    canModifyFolder: boolean = false;
    constructor(private fileHelper: FileHelperService, private toastr: ToastsManager, private vRef: ViewContainerRef) {
        if (this.isDocumentManager) {
            this.files = [];
            this.previousFiles = [];
        }
    }

    ngOnInit() {
        this.isMobile = DeviceHelper.isMobile() ? true : false

        if (this.moduleId != 4) {
            this.canModifyFolder = true
        }
        if (this.isDocumentManager) {
            this.GetFiles();
        }
    }

    validateFiles(events: any) {
        var emptyFiles = []
        var notemptyFiles = []

        for (var i = 0; i < events.length; i++) {
            var event = events[i]
            if (event.size == 0) {
                emptyFiles.push(event)
            }
            else {
                 notemptyFiles.push(event)
            }
        }

        if (emptyFiles.length > 0) {
            if (notemptyFiles.length > 0) {
                if (!confirm(`${notemptyFiles.map(e => e.name).join(',')} is/are empty file(s). These will be excluded. Do you still want to continue?`)) {
                    return
                }
                this.addFilesToBeUploaded(notemptyFiles)
                return
            }
            else {
                this.toastr.error('Please upload again', 'All files are empty')
                this.filesToBeUploaded = []

                this.updateFilesToBeUploaded.emit(this.filesToBeUploaded)
                return
            }
        }

        this.addFilesToBeUploaded(notemptyFiles)
    }

    addFilesToBeUploaded(event: any[]) {
        if (this.sendFilesMode) {
            this.toastr.error("Unable to upload file/s during selecting of files to be sent via email.");
            return;
        }

        if (this.isRootFolder) {
            this.toastr.error("Unable to upload file/s outside root folders.");
            return;
        }
        if (this.previousFiles.length == 0) {
            this.localPath = this.rootPath
        }
        else {
            this.localPath = this.previousFiles[this.previousFiles.length - 1].path
        }

        for (var i = 0; i < event.length; i++) {
            let formData: FormData = new FormData();
            formData.append("folderPath", this.localPath);
            formData.append("fileName", event[i].name);
            formData.append("fileSize", event[i].size);

            if (this.filesToBeUploaded.find(x => x.Name == event[i].name) != null) {
                this.resetAfterRequest(`The file ${event[i].name} already exists in file/s to be uploaded`, true);
                return;
            }

            this.fileHelper.checkDuplicate(formData).subscribe(
                (response) => {
                    response = JSON.parse(response._body)
                    if (response) {
                        this.resetAfterRequest(`The file ${event[i].name} already exists`, true);
                        return;
                    }

                    for (let index = 0; index < event.length; index++) {
                        const element = event[index];
                        var type = event[index].type;
                        var icon = this.fileHelper.getFileIcon(type);
                        var file = {
                            ParentPath: this.localPath,
                            Name: element.name,
                            Data: element,
                            Icon: icon
                        }
                        this.filesToBeUploaded.push(file);

                        if ((!this.isMobile && this.files.length < 6) || (this.isMobile && this.files.length < 8)) {
                            this.shownFiles.push(file);
                        }
                        else {
                            this.hiddenFiles.push(file);
                        }
                    }

                    this.updateFilesToBeUploaded.emit(this.filesToBeUploaded)
                },
                (error) => {
                    this.uploading = false
                    this.toastr.error("Please upload your file again");
                    return;
                }
            )
            return;
        }
    }

    uploadFileConfirm(event) {

        this.uploading = true;
        this.notify.emit(this.uploading)
        for (let index = 0; index < event.length; index++) {
            const element = event[index];

            if (this.history) {
                if (this.history.some(x => event[index].name == x.Name)) {
                    this.toastr.error("Upload not allowed", "File name already exists");
                    this.uploading = false;
                    this.fileInput.nativeElement.value = null;
                    continue;
                }
            }

            if (this.files.some(x => event[index].name == x.Name)) {
                this.toastr.error("Upload not allowed", "File name already exists");
                this.uploading = false;
                this.fileInput.nativeElement.value = null;
                continue;
            }

            var type = event[index].type;
            var icon = this.fileHelper.getFileIcon(type);

            this.files.push({
                Name: element.name,
                Data: element,
                Icon: icon
            });
            this.uploading = false;
            this.notify.emit(this.uploading)
            this.fileInput.nativeElement.value = null;
        }
    }

    removeFromDataToUpload(index: number) {
        this.files.splice(index, 1);
    }

    removeFile(event) {
        var shownFilesIndex = this.shownFiles.indexOf(event)
        if (shownFilesIndex > -1) {
            this.shownFiles.splice(shownFilesIndex, 1)
        }

        var hiddenFilesIndex = this.hiddenFiles.indexOf(event)
        if (hiddenFilesIndex > -1) {
            this.hiddenFiles.splice(hiddenFilesIndex, 1);
        }

        var filesToBeUploadedIndex = this.filesToBeUploaded.indexOf(event)
        this.filesToBeUploaded.splice(filesToBeUploadedIndex, 1);
    }

    canRemove(event) {
        if (this.filesToBeUploaded && this.filesToBeUploaded.indexOf(event) > -1) {
            return true;
        }
        return false
    }
    getFileProgress(filename) {
        var index = this.fileProgress.findIndex(x => x.name == filename)
        if (index > -1) {
            return this.fileProgress[index].progress
        }
        else return 0
    }

    IsAdminSharedFolder: any = false;
    isAccountAdmin: boolean = false;
    filesUpload: any[] = [];

    CurrentFolderName: string;
    GeneratingFolders: boolean;

    loadingFile: boolean = false;
    showUpload: boolean = false;

    get isRootFolder() {

        if (this.files == undefined) {
            return true;
        }

        if (this.files.some(x => x.IsRootFolder)) {
            return true;
        } else {
            return false;
        }
    }
    errorFileUploadTooLarge: boolean = false;
    uploadFile(event) {
        if (this.isRootFolder) {
            this.toastr.error("Unable to upload file/s outside root folders.");
            return;
        }
        if (!this.canModifyFolder) {
            this.toastr.error("Unable to upload file/s due to user's role.");
            return;
        }
        if (this.uploading || this.fileSelected) {
            this.toastr.error("Unable to upload file/s during uploading/downloading another file.");
            return;
        }
        this.uploading = true;

        if (this.previousFiles.length == 0) {
            this.localPath = this.rootPath
        }
        else {
            this.localPath = this.previousFiles[this.previousFiles.length - 1].path
        }

        for (let index = 1; index < this.previousFiles.length; index++) {
            this.pathName = this.pathName + this.previousFiles[index].name + "\\";
        }

        for (var i = 0; i < event.length; i++) {
            let formData: FormData = new FormData();
            formData.append("folderPath", this.localPath);
            formData.append("fileName", event[i].name);
            formData.append("fileSize", event[i].size);

            this.fileHelper.checkDuplicate(formData).subscribe(
                (response) => {
                    response = JSON.parse(response._body)
                    if (response) {
                        this.resetAfterRequest(`The file ${event[i].name} already exists`, true);
                        return;
                    }

                    this.progress = 1
                    if (event[i].size > 2147482624) {
                        this.uploadByChunk(event[i], this.localPath, this.pathName)
                        return;
                    }

                    this.uploadAsOne(event[i])
                },
                (error) => {
                    this.uploading = false
                    this.toastr.error("Please upload your file again");
                    return;
                }
            )
            return;
        }
    }

    public back() {
        this.files = this.previousFiles[this.previousFiles.length - 1].files;
        this.previousFiles.splice(this.previousFiles.length - 1, 1);

        if (this.files[0].IsRootFolder) {
            this.canModifyFolder = false
        }

        if (!this.isMobile && this.files.length > 6) {
            this.shownFiles = this.files.slice(0, 6)
            this.hiddenFiles = this.files.slice(6, this.files.length)
        }
        else if (this.isMobile && this.files.length > 8) {
            this.shownFiles = this.files.slice(0, 8)
            this.hiddenFiles = this.files.slice(8, this.files.length)
        }
        else {
            this.shownFiles = this.files
            this.hiddenFiles = []
        }
    }
    fileName = "";
    finalFilePath: string;
    public openFile(data: any) {

        //folder clicked
        if (data.Type == 1) {
            if (this.fileSelected || this.uploading) {
                this.toastr.error("Unable to click this folder at this moment. Please wait for the other file to be downloaded/uploaded.")
                return;
            }
            if (this.moduleId == 4) {
                this.canModifyFolder = data.CanModifyFolder
            }

            if (!this.isMobile && data.children.length > 6) {
                this.shownFiles = data.children.slice(0, 6)
                this.hiddenFiles = data.children.slice(6, data.children.length)
            }
            else if (this.isMobile && data.children.length > 8) {
                this.shownFiles = data.children.slice(0, 8)
                this.hiddenFiles = data.children.slice(8, data.children.length)
            }
            else {
                this.shownFiles = data.children
                this.hiddenFiles = []
            }

            if (!(this.noRootFolder && data.IsRootFolder)) {
                this.previousFiles.push({
                    name: data.Name,
                    files: this.files,
                    path: data.Path
                });
            }
            else {
                this.rootPath = data.Path
            }

            this.files = data.children
        } else {
            if (this.canRemove(data)) {
                return;
            }
            if (this.fileSelected || this.uploading) {
                this.toastr.error("Unable to download this file at this moment. Please wait for the other file to be downloaded/uploaded.")
                return;
            }
            this.progress = 1
            this.notify.emit(true)
            this.fileSelected = data
            data.downloadFile = true;
            var model = new FileDownloadModel();
            model.Path = data.FilePath;
            this.fileName = data.Name;
            this.request = this.fileHelper.downloadFile(model)
                .catch((err: any) => {
                    data.downloadFile = false;
                    this.resetAfterRequest("Error downloading file", true)
                    return Observable.throw(err);
                }).finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response) => {

                    if (response.type === HttpEventType.DownloadProgress) {
                        var percentage = Math.round(100 * response.loaded / response.total);
                        if (percentage > 0) this.progress = percentage
                        console.log(this.progress)
                    }

                    if (response.type === HttpEventType.Response) {
                        const file = new Blob([response.body], { type: 'text/plain' })
                        const downloadUrl = window.URL.createObjectURL(file);

                        var element = document.createElement('a');

                        element.setAttribute('href', downloadUrl);
                        element.setAttribute('download', data.Name);
                        element.click();

                        this.fileSelected = null
                        data.downloadFile = false;
                        this.toastr.success("File downloaded successfully.")
                        this.progress = 0
                        this.notify.emit(false)
                    }


                })
            this.requests.push(this.request)
        }
    }

    public GetFiles() {
        let formData: FormData = new FormData();
        var user = JSON.parse(localStorage.getItem('currentUser'));
        formData.append("AccountId", user.accountId.toString());
        formData.append("SiteId", this.siteId?.toString());
        formData.append("Role", this.role == null ? "" : this.role.Name);
        formData.append("ModuleId", this.moduleId.toString());
        formData.append("ModelId", this.model.Id.toString());
        formData.append("UserId", user.id.toString());
        formData.append("TaskId", !!!this.taskId ? "" : this.taskId.toString());
        formData.append("Name", this.name)

        if (this.allTemplate) {
            formData.append("AllTemplate", this.allTemplate.toString());
        }

        $.ajax({
            type: "POST",
            url: `${FileManager_PATH}/../GenericFileManageHandler.ashx`,
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: (response) => {

                this.files = response
                if (!this.isMobile && response.length < 6) {
                    this.shownFiles = response.slice(0, 6)
                    this.hiddenFiles = response.slice(6, response.length)
                }
                else if (this.isMobile && response.length < 8) {
                    this.shownFiles = response.slice(0, 8)
                    this.hiddenFiles = response.slice(8, response.length)
                }
                else {
                    this.shownFiles = response;
                    this.hiddenFiles = []
                }

                if (this.noRootFolder) {
                    if (response[0].children.length == 0) {
                        this.hasFiles.emit(false)
                    }
                    else {
                        this.hasFiles.emit(true)
                    }
                    this.openFile(this.files[0]);
                }
                else {
                    this.hasFiles.emit(true)
                }
                this.uploading = false
                this.filesLoaded.emit(true)
            },
            error: (err) => {
                this.filesLoaded.emit(true)
                this.resetAfterRequest("Error loading file manager", true)
            }
        });
    }

    base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    public uploadAsOne(events: any[]) {
        //this.progress = 1
        //var index = 1
        this.eventsLength = events.length
        this.uploadedFileCtr = 0
        this.uploading = true;
        events.forEach(file => {
            if (this.previousFiles.length == 0) {
                this.localPath = this.rootPath
            }
            else {
                this.localPath = this.previousFiles[this.previousFiles.length - 1].path
            }

            for (let index = 1; index < this.previousFiles.length; index++) {
                this.pathName = this.pathName + this.previousFiles[index].name + "\\";
            }

            this.hasFiles.emit(true)
            if (file.size > 2147482624) {
                this.uploadByChunk(file, this.localPath, this.pathName)
                return;
            }

            let formData = new FormData()
            formData.append('uploadedFiles', file, file.name);
            formData.append("localPath", this.localPath);
            formData.append("pathName", this.pathName);
            formData.append("userId", this.user.id);
            formData.append("siteId", this.siteId?.toString());
            formData.append("moduleId", this.moduleId.toString());

            this.requests.push(this.fileHelper.uploadAsOne(formData).subscribe((event: HttpEvent<any>) => {
                if (event.type === HttpEventType.UploadProgress) {

                    var percentage = Math.round(event.loaded / event.total * 99)
                    if (this.fileProgress.findIndex(x => x.name == file.name) == -1) {
                        this.fileProgress.push({
                            name: file.name,
                            progress: percentage
                        })
                    }
                    else {
                        var index = this.fileProgress.findIndex(x => x.name == file.name)
                        this.fileProgress[index].progress = percentage
                    }
                }
                if (event.type === HttpEventType.Response) {
                    this.uploadedFileCtr++
                    var response = event.body
                    if (this.files != null) {
                        response.files.forEach(r => {
                            var index = this.filesToBeUploaded.findIndex(x => x.Name == r.Name)
                            this.filesToBeUploaded.splice(index, 1)
                        });
                    }
                    if (this.uploadedFileCtr == this.eventsLength) {
                        this.resetAfterRequest("Updated successfully")
                        this.filesToBeUploaded = []
                    }
                }
            }))
            //index++
        });



    }

    uploadByChunk(file, finalFilePath, pathName) {
        this.uploadChunksRequest = true
        this.notify.emit(this.uploading)
        this.chunkedFilesFolderName = `${this.siteId}_${Date.now()}_${randomString(randomNumber(10))}`
        var blob = file;
        var BYTES_PER_CHUNK = 90000000; // sample chunk sizes.
        var SIZE = blob.size;
        var context = this
        //upload content
        var start = 0;
        var end = BYTES_PER_CHUNK;
        var completed = 0;
        var count = SIZE % BYTES_PER_CHUNK == 0 ? SIZE / BYTES_PER_CHUNK : Math.floor(SIZE / BYTES_PER_CHUNK) + 1;
        var ctr = 0
        while (start < SIZE) {

            //stop the loop when uploading was cancelled
            if (!this.uploading) {
                return;
            }

            var chunk = blob.slice(start, end);

            var formData = new FormData();
            formData.append('chunkedFilesFolderName', this.chunkedFilesFolderName);
            formData.append('prefixFileName', `${ctr}`);
            formData.append('chunk', chunk);

            this.requests.push(this.fileHelper.uploadByChunks(formData).subscribe(
                (response) => {
                    completed = completed + 1;

                    var percentage = Math.round(completed / count * 99);
                    if (percentage > 0) this.progress = percentage

                    if (this.fileProgress.findIndex(x => x.name == file.name) == -1) {
                        this.fileProgress.push({
                            name: file.name,
                            progress: percentage
                        })
                    }
                    else {
                        var index = this.fileProgress.findIndex(x => x.name == file.name)
                        this.fileProgress[index].progress = percentage
                    }

                    if (completed === count) {
                        this.fileName = file.name
                        this.finalFilePath = finalFilePath
                        mergeChunkedFiles(this.fileName, finalFilePath, context, this.chunkedFilesFolderName, pathName);
                    }
                },
                (error) => {
                }
            ))

            start = end;
            end = start + BYTES_PER_CHUNK;
            ctr++
        }
    }
    cancelRequest() {
        this.toastr.info("Cancelling request...")

        this.isCancellingRequest = true
        this.uploading = false

        var message = "Uploading was cancelled successfully"

        this.requests.forEach(element => {
            element.unsubscribe()
        });

        if (this.uploadChunksRequest) {
            var formData = new FormData()
            formData.append('chunkedFilesFolderName', this.chunkedFilesFolderName);

            this.fileHelper.deleteUploadedChunks(formData)
                .catch((err: any) => {
                    this.resetAfterRequest(message)
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe(() => {
                    this.resetAfterRequest(message, false, true)
                })

        }

        else if (this.mergeFileRequest) {
            var formData = new FormData()
            formData.append('fileName', this.fileName);
            formData.append('localpath', this.finalFilePath);
            formData.append("savedPath", this.pathName)
            formData.append("siteId", this.siteId.toString())

            this.fileHelper.deleteMergedChunks(formData)
                .catch((err: any) => {
                    this.resetAfterRequest("Failed to cancel upload.", true)
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe(() => {
                    this.resetAfterRequest(message, false, true)
                })

        }
        else {

            if (this.fileSelected) {
                message = "Downloading was cancelled successfully"
                this.fileSelected.downloadFile = false
                this.resetAfterRequest(message, false, true)
            }
            else {
                var formData = new FormData()
                formData.append("filePath", this.localPath)
                formData.append("fileName", this.fileName)
                formData.append("savedPath", this.pathName)
                formData.append("siteId", this.siteId.toString())

                this.fileHelper.deleteFile(formData)
                    .catch((err: any) => {
                        this.resetAfterRequest("Failed to cancel upload.", true)
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe(() => {
                        this.resetAfterRequest(message, false, true)
                    })
            }
        }

    }

    resetAfterRequest(message = null, error = false, info = false) {
        this.filesToBeUploaded = []
        this.fileProgress = []
        this.uploadChunksRequest = false
        this.mergeFileRequest = false
        this.isCancellingRequest = false
        this.progress = 0
        this.uploading = false
        this.fileSelected = null
        this.notify.emit(this.uploading)

        if (message) {
            if (error) this.toastr.error(message)
            else if (info) this.toastr.info(message)
            else this.toastr.success(message)
        }
    }

    toggleExpand() {
        this.isExpanded = !this.isExpanded
    }

    setSelectedFiles(file) {
        if (this.filesToBeSent.find(x => x.Name == file.Name)) {
            this.toastr.error("File must be uploaded.")
        }
        var path = `${file.ParentPath}`
        if (file.Name) {
            path = `${path}\\${file.Name}`
        }

        var index = this.filesToBeSent.findIndex(x => x.path == path);

        if (index > -1) {
            this.filesToBeSent.splice(index, 1)
        }
        else {
            this.filesToBeSent.push({
                path: path,
                icon: file.Icon,
                name: file.Name
            })
        }
    }

    isSelected(file) {
        var path = `${file.ParentPath}`
        if (file.Name) {
            path = `${path}\\${file.Name}`
        }

        var index = this.filesToBeSent.findIndex(x => x.path == path);

        if (index > -1) {
            return true
        }
        return false
    }

    selectAllFiles() {
        this.files.forEach(x => {
            var path = x.ParentPath
            if (x.Name) {
                path = `${path}\\${x.Name}`
            }

            var index = this.filesToBeSent.findIndex(x => x.path == path);
            if (index < 0) {
                this.filesToBeSent.push({
                    path: path,
                    icon: x.Icon,
                    name: x.Name
                })
            }
        })
    }

    unselectAllFiles() {
        this.filesToBeSent = []
    }

    get noRootFolder() {
        var ids = [5, 30, 11]
        return ids.includes(this.moduleId)
    }

}


function mergeChunkedFiles(fileName, finalFilePath, context, chunkedFilesFolderName, pathName) {
    context.uploadChunksRequest = false
    context.toastr.info("Finalizing...");

    var formData = new FormData();
    formData.append('fileName', fileName);
    formData.append('path', finalFilePath);
    formData.append('userId', context.user.id)
    formData.append('siteId', context.siteId)
    formData.append('moduleId', context.moduleId.toString())
    formData.append('pathName', pathName)
    formData.append('chunkedFilesFolderName', chunkedFilesFolderName)

    context.requests = []
    context.mergeFileRequest = true
    context.requests.push(context.fileHelper.mergeFiles(formData).subscribe(
        (response) => {
            context.uploadedFileCtr++
            context.progress = 100
            response = JSON.parse(response._body)

            if (context.files != null) {
                response.files.forEach(r => {
                    var index = context.filesToBeUploaded.findIndex(x => x.Name == r.Name)
                    context.filesToBeUploaded.splice(index, 1)
                });
            }

            if (context.uploadedFileCtr == context.eventsLength) {
                context.resetAfterRequest("Updated successfully")
                context.filesToBeUploaded = []
            }
        },
        (error) => {
            context.progress = 0
            context.uploading = false
            context.notify.emit(false)
            context.toastr.error(error.message);
        }
    ))
}



// WEBPACK FOOTER //
// ./src/app/components/file-handler/file-handler.component.ts